/* eslint-disable */
<template>
  <WithTopNav :leftText="$t('meu.Deposit')" fixed>
  <div class="deposito flex flex-col h-[100vh] w-full">
    <template v-if="!thirdPartyUrl">
      <div class="mt-4 px-[20px] flex-1">
        <div class="text-[15px]">{{ $t('Deposit.Paymentchannel') }}</div>
        <div class="w-[353px] h-[35px] m-auto overflow-x-auto relative mt-4">
          <div class="absolute flex gap-[10px]">
            <template v-if="paymentType?.length">
              <template v-for="(item, index) in paymentType" :key="item.methodId">
                <div class="relative">
                  <div
                    :class="[
                      'w-[85px] h-[35px] text-[18px] flex justify-center items-center rounded-[6px] cursor-pointer',
                      methodId === item.id
                        ? 'bg-[#2C7952]'
                        : 'bg-[#2C795233] text-[#bdbec0]',
                    ]"
                    @click="handleClick(item)"
                  >
                    {{ methodId === item.id ? "PIX" : "pix" }}-{{ index + 1 }}
                  </div>
                  <div
                    v-if="item.type === 'TestPay'"
                    class="absolute top-[-2px] right-[-10px] w-[20px] h-[20px] rounded-full bg-[red] text-white text-[10px] flex-center"
                  >
                    T
                  </div>
                </div>
              </template>
            </template>
          </div>
        </div>
        <div class="w-full mt-6">
          <!-- 单选 -->
          <template v-if="enabled">
            <van-checkbox v-model="isDiscount">
              {{ $t('Deposit.ParticipateInpromotions') }}
              <template #icon>
                <img
                  class="h-[20px] w-[20px]"
                  :src="isDiscount ? activeIcon : inactiveIcon"
                />
              </template>
            </van-checkbox>
          </template>
        </div>
        <!-- 输入金额 -->
        <div class="h-[50px] rounded-xl mt-[10px] flex items-center relative">
          <span class="absolute left-[15px] font-bold text-[#FFDF12] text-[15px]">
            R$
          </span>
          <input
            type="number"
            :placeholder="`${$t('Deposit.valor')}(${dealProportion(limitMin || 0)} ~ ${dealProportion(
              limitMax || 0
            )})`"
            v-model="money"
            @change="handleInput"
            class="w-[100%] h-[100%] rounded-xl bg-[#2C7952]/40 text-[15px] indent-[47px] border-none placeholder:text-[15px] placeholder:text-[#FFFFFFBF] focus:outline-none focus:ring-[#D1DBBD] focus:ring-[2px] focus:bg-[#5a4be2 ]"
          />
          <div class="absolute right-[15px] flex items-center gap-[10px]">
            <template v-if="money">
              <van-icon name="close" @click="money = null" />
            </template>
          </div>
        </div>
        <!-- 优惠金额 -->
        <template v-if="isDiscount">
          <div
            class="h-[50px] rounded-xl bg-[#2C7952]/20 flex items-center gap-[10px] mt-[20px] pl-[15px] text-[#bcbec1]"
          >
            <Image class="w-[24px]" :src="disCount" alt="" />
            <span class="text-[15px]">
             {{ $t('Deposit.ParticipateInpromotions') }}
              {{
                (money * (chooseBtn?.rewardRatios || 0)) / 100 > maxAmount
                  ? formatter().format(maxAmount)
                  : formatter().format(
                      parseFloat(
                        (
                          Math.floor(
                            ((money * (chooseBtn?.rewardRatios || 0)) / 100) * 100
                          ) / 100
                        ).toFixed(2)
                      )
                    )
              }}
            </span>
          </div>
        </template>
        <!-- 优惠金额 -->
        <div class="flex justify-between flex-wrap mt-[10px]">
          <template v-if="enabled && isDiscount">
            <div v-for="item in giftMoneyArr" :key="item.giftCode">
              <button
                :class="[
                  'w-[100px] h-[38px] border-[1px] border-[#fff]/50 rounded-[8px] mr-[5px]  mt-[10px]',
                  chooseBtn?.giftCode !== item.giftCode ? 'bg-[#151A1F]' : 'bg-[#64F765]',
                ]"
                @click="
                  () => {
                    chooseBtn = item;
                    maxAmount = item?.maxAmount || 100;
                  }
                "
              >
                <span
                  :class="{
                    'text-[#2F1780] font-[600]': chooseBtn?.giftCode === item.giftCode,
                  }"
                >
                  {{ dealProportion(item.rewardRatios) }}%
                </span>
              </button>
            </div>
          </template>
          <template v-else>
            <div v-for="item in generalMoneyArr" :key="item.amount">
              <button
                :class="[
                  'w-[100px] h-[38px] border-[1px] border-[#fff]/50 rounded-[8px] mr-[5px] mt-[10px]',
                  Number(item.amount) > limitMax || Number(item.amount) < limitMin
                    ? 'opacity-40'
                    : '',
                  money !== `${item.amount}` ? 'bg-[#151A1F]' : 'bg-[#64F765]',
                ]"
                :disabled="
                  Number(item.amount) > limitMax || Number(item.amount) < limitMin
                "
                @click="
                  () => {
                    money = item.amount;
                  }
                "
              >
                <span
                  :class="[
                    money === `${item.amount}` ? 'text-[#151A1F]  font-bold' : '',
                    'text-[14px]',
                  ]"
                >
                  R$ {{ dealProportion(item.amount) }}
                </span>
              </button>
            </div>
          </template>
        </div>
        <!-- 无优惠打码量说明 -->
        <template v-if="!isDiscount">
          <div
            class="h-[45px] rounded-[8px] border-[1px] border-solid border-[#FFFFFF] flex items-center gap-[10px] mt-[20px] pl-[15px] text-[#fff] opacity-50"
          >
            <Image :src="important" alt="" class="w-[24px] h-[24px]" />
            <span class="text-[13px]">
             {{ $t('Deposit.NoDiscountCodeQuantity', { turnoverTimes: turnoverTimes }) }}  
            </span>
          </div>
        </template>
        <!-- 有优惠打码量说明 -->
        <template v-else>
          <div
            class="rounded-xl border-[1px] border-solid border-[#fff]/75 mt-[20px] p-[10px] text-[#fff]/75"
          >
            <div class="flex items-start gap-[10px] leading-[22px]">
              <div class="rounded-[50%] mt-1">
                <Image :src="important" class="w-[16px] h-[16px]" alt="" />
              </div>
              <div>
                <p>
                  {{ $t('Deposit.DepositReceives', { rewardRatios: dealProportion(chooseBtn?.rewardRatios) }) }}
                </p>
                <p>
                  {{ $t('Deposit.MaximumBonusAmount', { maxAmount: formatter().format(chooseBtn?.maxAmount) }) }}
                </p>
                <p>
                  {{ $t('Deposit.BonusCanBeWthdrawn', { rollingRatio: formatter().format(chooseBtn?.rollingRatio) }) }}
                </p>
              </div>
            </div>
            <div class="flex items-center gap-[10px] leading-[22px]">
              <div>
                <img
                  :src="chooseBtn?.userCondition ? right : error"
                  class="w-[16px] h-[16px]"
                  alt=""
                />
              </div>
              <span>
                {{ userTypeOptions[chooseBtn?.scope]?.text }}
                <template
                  v-if="chooseBtn?.scope !== 'All' && chooseBtn?.scope !== 'FirstDeposit'"
                >
                  {{ formatter().format(chooseBtn?.configAmount) }}
                </template>
              </span>
            </div>
            <div class="flex items-center gap-[10px] leading-[22px]">
              <div class="rounded-[50%]">
                <img
                  :src="chooseBtn?.dailyCondition ? right : error"
                  class="w-[16px] h-[16px]"
                  alt=""
                />
              </div>
              <span>
                <template v-if="chooseBtn?.perDayRewardTimes > 0">
                  {{ $t('Deposit.TimesADay', { perDayRewardTimes: chooseBtn?.perDayRewardTimes }) }}
                </template>
                <template v-else>{{ $t('Deposit.NoLimitOfTimes') }}</template>
              </span>
            </div>
          </div>
        </template>
        <div class="text-[#fff]/50 mt-6">
          <van-button
            :loading="isLoading"
            :class="[
              'primaryBtn_disabled',
              {
                '!text-[#2F1780]/100 font-bold !bg-[#64F765] !border-[#64F765]':
                  +money >= limitMin &&
                  +money <= limitMax &&
                  !isLoading &&
                  (!isDiscount ||
                    (chooseBtn?.userCondition && chooseBtn?.dailyCondition)),
              },
            ]"
            :disabled="
              +money < limitMin ||
              +money > limitMax ||
              isLoading ||
              (isDiscount && !chooseBtn?.userCondition) ||
              (isDiscount && !chooseBtn?.dailyCondition)
            "
            @click="handleDeposito()"
          >
            {{ $t('meu.Deposit') }}
          </van-button>
        </div>
        <van-popup
          v-if="openModal"
          v-model:show="openModal"
          position="bottom"
          :style="{ height: '70%' }"
        >
          <PopPage
            :uuPayForm="uuPayForm"
            @closeModal="openModal = false"
            :_createOrder="_createOrder"
          />
        </van-popup>
      </div>
    </template>
    <template v-else>
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        :src="thirdPartyUrl"
        style="overflow: hidden"
      ></iframe>
    </template>
  </div>

  <!-- <BottomBar /> -->
   </WithTopNav>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import useTrack from "@/hooks/useTrack";
import { formatter } from "@/utils";
import { getPayChannel } from "@/api/saque";
import { getMoneyButtonList, getProportionButtonList, createOrder } from "@/api/deposito";
import type { iType } from "@/types/index";
import { useUserInfo } from "@/store";
import debounce from "lodash-es/debounce";
import activeIcon from "@/themes/theme_a/views/Deposito/images/check.png";
import inactiveIcon from "@/themes/theme_a/views/Deposito/images/nocheck.png";
import disCount from "@/themes/theme_a/views/Deposito/images/disCount2.png";
import important from "@/themes/theme_a/views/Deposito/images/important.png";
import right from "@/themes/theme_a/views/Deposito/images/right.png";
import error from "@/themes/theme_a/views/Deposito/images/error.png";
import PopPage from "./compontents/PopPage.vue";
import WithTopNav from '@/layouts/withTopNav.vue'
const { track2Platform, trackName } = useTrack();
import { useSystemInfo } from "@/store";
const router = useRouter();
const token = useUserInfo().userInfo?.token;
import i18n from "@/i18n";
const t = i18n.global.t;
const userTypeOptions = {
  All: {
    text: t('Deposit.UserTypeOptions.All'),
  },
  FirstDeposit: {
    text: t('Deposit.UserTypeOptions.FirstDeposit'),
  },
  CurrentDeposit: {
    text: t('Deposit.UserTypeOptions.CurrentDeposit'),
  },
  CurrentBet: {
    text: t('Deposit.UserTypeOptions.CurrentBet'),
  },
  AccumulateDeposit: {
    text: t('Deposit.UserTypeOptions.AccumulateDeposit'),
  },
  AccumulateBet: {
    text: t('Deposit.UserTypeOptions.AccumulateBet'),
  },
};

const paymentType = ref<iType[]>([]); //渠道列表

const methodId = ref<any>(null); //渠道id
const limitMin = ref<any>(null); //最小金额
const limitMax = ref<any>(null); //最大金额
const payType = ref<any>(null); //支付渠道类型
const money = ref<any>(null); //输入金额
const isLoading = ref<boolean>(false); //是否加载中
const isDiscount = ref<boolean>(false); //是否优惠
const chooseBtn = ref<any>({}); //选择优惠
const enabled = ref<boolean>(true); //是否启用
const maxAmount = ref<any>(1000); //优惠最大金额
const giftMoneyArr = ref<any>([]); //优惠金额
const generalMoneyArr = ref<any>([]); //普通金额
const turnoverTimes = ref<any>(0); //打码量
const openModal = ref(false); //是否打开弹窗
const uuPayForm = ref<any>({ payeeName: "", payeeCpf: "" }); //uu支付表单
const thirdPartyUrl = ref<any>(""); //第三方url
// 获取渠道列表
const getChannelList = async () => {
  try {
    const { data, code } = await getPayChannel({
      type: "Recharge",
    });
    if (code === 1) {
      paymentType.value = data;
      data[0]?.id && (methodId.value = data[0].id);
      data[0]?.minPayeeAmt && (limitMin.value = data[0].minPayeeAmt);
      data[0]?.maxPayeeAmt && (limitMax.value = data[0].maxPayeeAmt);
      data[0]?.type && (payType.value = data[0].type);
    }
  } catch (error) {
    console.log("getChannelList - error:", error);
  }
};

// 获取普通充值按钮列表
const getButtonList = async () => {
  try {
    const { code, data }: any = await getMoneyButtonList();
    if (code === 1) {
      generalMoneyArr.value = data;
      turnoverTimes.value = 1;
    }
  } catch (error) {
    console.log("getButtonList - error:", error);
  }
};

// 获取充值比例按钮列表
const getProportionButtonListData = async () => {
  try {
    const { code, data }: any = await getProportionButtonList();
    if (code === 1) {
      enabled.value = data.enabled;
      if (enabled.value) {
        isDiscount.value = true;
      }
      giftMoneyArr.value = data.detailList;
      chooseBtn.value = giftMoneyArr.value[0];
    }
  } catch (error) {
    console.log("getProportionButtonList - error:", error);
  }
};

// 选择渠道
const handleClick = (item: iType) => {
  payType.value = item.type;
  methodId.value = item.id;
  limitMin.value = item.minPayeeAmt;
  limitMax.value = item.maxPayeeAmt;
  if (
    money.value &&
    (Number(money.value) < Number(limitMin.value) ||
      Number(money.value) > Number(limitMax.value))
  ) {
    money.value = null;
  }
};

// 输入金额
const handleInput = (e: any) => {
  const value = e.target.value.replace(/^(\d+(\.\d{0,2})?).*$/, "$1");
  const num = Number(value) > limitMax.value ? limitMax.value : value;
  money.value = num;
};

// 处理比例
const dealProportion = (val: any) => {
  const floatValue = parseFloat(val);
  if (floatValue % 1 === 0) {
    return floatValue.toFixed(0);
  } else {
    if (useSystemInfo().language === "pt") {
      return floatValue.toString().replace(".", ",");
    } else {
      return floatValue.toString();
    }
  }
};

// 提交
const handleDeposito = debounce(async () => {
  if (isLoading.value) return;
  isLoading.value = true;
  try {
    const currentChannel: any = paymentType.value.find(
      (item) => item.id === methodId.value
    );
    if (["Required", "SupportNeeds"].includes(currentChannel.payeeInfoFlag)) {
      uuPayForm.value = {
        payeeName: "",
        payeeCpf: "",
      };
      openModal.value = true;
      isLoading.value = false;
    } else {
      _createOrder();
    }
  } catch (error) {
    console.log(error);
    isLoading.value = false;
  }
}, 1000);
// 创建订单
const _createOrder = async (data = {}) => {
  let res = await createOrder({
    payType: payType.value,
    amount: +money.value,
    ...(isDiscount.value && { giftCode: chooseBtn.value.giftCode }),
    ...data,
  });
  if (res.code === 1) {
    // limitReturnUrl 为true跳转我们的支付页面，为false跳转第三方页面
    if (res.data.limitReturnUrl) {
      //模拟充值
      router.push({
        path: "/DepositoQRcode",
        query: { orderNo: res.data.merchantOrderNo, token, ...res.data },
      });
    } else if (res.data.orderStatus == "PullFailed") {
      // 拉单失败
      router.push({
        path: "/DepositoResults",
        query: { orderNo: res.data.merchantOrderNo, ...res.data, status: "PullFailed" },
      });
    } else {
      //第三方链接返回不正规直接返回充值错误页
      if (res.data.payUrl.includes("https://")) {
        thirdPartyUrl.value = res.data.payUrl;
      } else {
        router.push({
          path: "/DepositoResults",
          query: { orderNo: res.data.merchantOrderNo, ...res.data, status: "PullFailed" },
        });
      }
    }

    track2Platform(trackName.InitiateCheckout, {
      value: +money.value,
      currency: res.data.currency,
      product_catalog_id: res.data.id,
    });
  }

  isLoading.value = false;

  return { code: 1 };
};

onMounted(() => {
  getChannelList();
  getButtonList();
  getProportionButtonListData();
  track2Platform(trackName.AddToCart);
});
</script>

<style lang="scss" scoped>
.van-checkbox {
  --van-checkbox-label-color: #fff;
  font-size: 14px;
}
</style>
